import React, { useState } from 'react'
import { Checkbox, Tooltip, Image, Typography } from 'antd'
import _, { isArray } from 'lodash'
import styles from './index.module.less'
import SkuDynamicContent from '../SkuDynamicContent'
const { Paragraph } = Typography
const KitDetailContent = ({
  disabled = false,
  kitList = [], //必选项
  noMustChooseList = [], // 可选项
  setMustChooseList = () => ({}),
  setNoMustChooseList = () => ({}),
  formatCombinationData = () => ({}),
}: any) => {
  const tagsMap = {
    NATIONAL_UPPLEMENT: 'nationalCss',
  }

  // 单个选材勾选
  const singleMaterialCheck = (e: any, index: any) => {
    const newData = _.cloneDeep(noMustChooseList)
    newData[index].checked = e.target.checked
    formatCombinationData(kitList, newData, true)
  }

  const onSubmitSkuDynamicVoList = async (value, kit) => {
    console.log(value, 'value')
    if (value?.filter((item: any) => item.optionId).length !== kit.skuDynamicVoList?.length) return
    // 所有选项选完才更新
    const newData = kit.required ? _.cloneDeep(kitList) : _.cloneDeep(noMustChooseList)
    let currentIndex = newData.findIndex((item: any) => item.id === kit.id)
    newData[currentIndex].materialDynaOptions = value
    if (kit.required) {
      setMustChooseList(newData)
    } else {
      setNoMustChooseList(newData)
    }
  }
  const showNationalTagRender = (kit: any) => {
    // // 当确定skuid后 显示国补
    let showTags = kit?.skuList?.find((sku: any) => sku.id === kit?.selectSkuId)?.showTags
    if (showTags && isArray(showTags)) {
      return showTags?.map((tag: any) => {
        return (
          <div className={tagsMap[tag.tagCode]}>
            <Tooltip placement="topLeft" title={tag.tagName}>
              {tag.tagName}
            </Tooltip>
          </div>
        )
      })
    } else {
      return <></>
    }
  }
  const dynaOptionRender = (kit: any) => {
    console.log(kit, 'kit')
    // 只有一个sku的时候只展示规格内容
    if (kit.skuList?.length === 1) {
      let argMap = kit.skuList[0]?.argMap
      let str = ''
      Object?.keys(argMap)?.forEach((key: any) => {
        str += argMap[key]?.argName + '：' + argMap[key]?.valueName + '；'
      })
      return str
    }
  }
  const dialogContent = () => {
    return (
      <>
        <div className={styles.KitDetailDialogBox}>
          {kitList &&
            kitList?.length !== 0 &&
            kitList.map((kit: any, index: any) => {
              if (kit.allowView) {
                return (
                  <>
                    <div className={styles.orderDetail} key={'kit' + index}>
                      <div className={styles.orderDetailInfoBox}>
                        <div className={styles.imgBox}>
                          <Image.PreviewGroup items={kit?.product?.imageUrls || undefined}>
                            <Image src={kit?.mainPicUrl} className={styles.img} />
                          </Image.PreviewGroup>
                        </div>
                        <div className={styles.orderDetailInfo}>
                          <div className={styles.infoTitle}>
                            <div className={styles.descTitle}>
                              {showNationalTagRender(kit)}
                              <Tooltip title={kit?.prodName} placement="topLeft">
                                <p> {kit?.prodName}</p>
                              </Tooltip>
                            </div>
                          </div>
                          <div className={styles.kitId}>
                            <span style={{marginRight: '4px'}}>SPU: </span> 
                            <Paragraph copyable>{kit.id}</Paragraph>
                          </div>
                          <div className={styles.footInfo}>
                            {kit.skuList?.length === 1 && dynaOptionRender(kit)&& (
                              <div className={styles.houseInfo}>
                                <div>规格：{dynaOptionRender(kit)}</div>
                              </div>
                            )}
                          </div>
                          <div className={styles.footInfo}>
                            {kit.product?.brandName && (
                              <div className={styles.houseInfo}>
                                <div>品牌：{kit.product?.brandName}</div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      {kit?.useArgList &&
                        kit?.useArgList?.length !== 0 &&
                        kit?.useArgList?.map((item: any, itemIndex: number) => {
                          return kit?.allowView ? (
                            <div key={'kitItem' + itemIndex}>
                              <div className={styles.chooseTitle}>
                                <span className={styles.mustChoose}>*</span>
                                <span className={styles.titleFont}>{item?.argName}</span>
                              </div>
                              <div className={styles.chooseList}>
                                {item?.list &&
                                  item?.list?.length !== 0 &&
                                  item?.list?.map((attr: any, attrIndex: number) => (
                                    <div
                                      key={'kitItemAttr' + attrIndex}
                                      className={`${styles.item} ${ attr.isActive ? styles.itemActive : '' } ${styles.disabled}`}
                                      onClick={() => {
                                        return;
                                      }}
                                    >
                                      <span className={`${styles.radio} ${''}`}></span>
                                      <div>{attr.valueName}</div>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          ) : null
                        })}
                      {/* 动态属性 */}
                      <SkuDynamicContent
                        loading={false}
                        formList={
                          kit?.materialDynaOptions
                            ? kit?.materialDynaOptions
                            : kit?.skuDynamicVoList
                        }
                        onSubmit={onSubmitSkuDynamicVoList}
                        currentItem={kit}
                      ></SkuDynamicContent>
                    </div>
                  </>
                )
              }
            })}
        </div>
        {noMustChooseList?.length ? (
          <>
            <div className={styles.classTitle}>可选项</div>
            <div className={styles.KitDetailDialogBox}>
              {noMustChooseList &&
                noMustChooseList?.length !== 0 &&
                noMustChooseList.map((kit: any, index: any) => {
                  if (kit.allowView) {
                    return (
                      <>
                        <div className={styles.orderDetail} key={'kit' + index}>
                          <div className={styles.orderDetailInfoBox}>
                            <div style={{ display: 'flex', marginRight: '8px' }}>
                              <Checkbox
                                disabled
                                checked={kit.checked}
                                defaultChecked={kit.checked}
                                onChange={(e: any) => {
                                  singleMaterialCheck(e, index)
                                }}
                              ></Checkbox>
                            </div>
                            <div className={styles.imgBox}>
                              <Image.PreviewGroup items={kit?.product?.imageUrls || undefined}>
                                <Image src={kit?.mainPicUrl} className={styles.img} />
                              </Image.PreviewGroup>
                            </div>
                            <div className={styles.orderDetailInfo}>
                              <div className={styles.infoTitle}>
                                <div className={styles.descTitle}>
                                  {showNationalTagRender(kit)}
                                  <Tooltip title={kit?.prodName} placement="topLeft">
                                    <span> {kit?.prodName}</span>
                                  </Tooltip>
                                </div>
                              </div>
                              <div className={styles.kitId}>
                                 <span style={{marginRight: '4px'}}>SPU: </span> 
                                <Paragraph copyable>{kit.id}</Paragraph>
                              </div>
                              <div className={styles.footInfo}>
                                {kit.skuList?.length === 1 && dynaOptionRender(kit)&& (
                                  <div className={styles.houseInfo}>
                                    <div>规格：{dynaOptionRender(kit)}</div>
                                  </div>
                                )}
                              </div>
                              <div className={styles.footInfo}>
                                {kit.product?.brandName && (
                                  <div className={styles.houseInfo}>
                                    <div>品牌：{kit.product?.brandName}</div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          {kit?.useArgList &&
                            kit?.useArgList?.length !== 0 &&
                            kit?.useArgList?.map((item: any, itemIndex: number) => {
                              return (
                                <div key={'kitItem' + itemIndex}>
                                  <div className={styles.chooseTitle}>
                                    <span className={styles.mustChoose}>*</span>
                                    <span className={styles.titleFont}>{item?.argName}</span>
                                  </div>
                                  <div className={styles.chooseList}>
                                    {item?.list &&
                                      item?.list?.length !== 0 &&
                                      item?.list?.map((attr: any, attrIndex: number) => (
                                        <div
                                          key={'kitItemAttr' + attrIndex}
                                          className={`${styles.item} ${ attr.isActive ? styles.itemActive : '' } ${styles.disabled}`}
                                          onClick={() => {
                                            return;
                                          }}
                                        >
                                          <span className={`${styles.radio} ${''}`}></span>
                                          <div>{attr.valueName}</div>
                                        </div>
                                      ))}
                                  </div>
                                </div>
                              )
                            })}
                          {/* 动态属性 */}
                          <SkuDynamicContent
                            loading={false}
                            formList={
                              kit?.materialDynaOptions
                                ? kit?.materialDynaOptions
                                : kit?.skuDynamicVoList
                            }
                            onSubmit={onSubmitSkuDynamicVoList}
                            currentItem={kit}
                          ></SkuDynamicContent>
                        </div>
                      </>
                    )
                  }
                })}
            </div>
          </>
        ) : null}
      </>
    )
  }

  return <div className={styles.KitDetailDialog}>{dialogContent()}</div>
}

export default KitDetailContent
